import { Button, Modal, TextField, FormLayout, Form, Select, Checkbox } from '@shopify/polaris';
import { useState, useCallback, useEffect } from 'react';
import { listRoles } from '../../../services/rolesService';
import { listDeposits } from '../../../services/depositsService';
import { Multiselector } from '../Deposits/MultiSelector.jsx';

const defaultSignUp = {
  name: '',
  surname: '',
  phone: '',
  email: '',
  password: '',
  role: '',
  operationDeposits: [],
  transferDeposits: [],
  canViewSells: true,
};

export const NewUserModal = ({ onAddUser }) => {
  const [active, setActive] = useState(false);
  const handleChange = useCallback(() => setActive(!active), [active]);
  const [signUpForm, setSignUpForm] = useState(defaultSignUp);
  const [operationDeposits, setOperationDeposits] = useState([]);
  const [transferDeposits, setTransferDeposits] = useState([]);
  const [pwconfirm, setPwconfirm] = useState(false);
  const [pwconfirmValue, setPwconfirmValue] = useState('');
  const [roles, setRoles] = useState([]);

  const activator = (
    <Button onClick={handleChange} primary="primary" size="slim">
      Nuevo usuario
    </Button>
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!pwconfirm) throw new Error('Las contraseñas no coinciden');
    try {
      await onAddUser(signUpForm);
      setSignUpForm(defaultSignUp);
      setPwconfirm(false);
      setPwconfirmValue('');
      setActive(false);
    } catch (e) {}
  };

  useEffect(() => {
    listRoles().then((r) => {
      setRoles(r.data.roles);
      setSignUpForm((s) => ({ ...s, role: r.data.roles[0].slug }));
    });
    listDeposits().then((d) => setOperationDeposits(d.data.data));
    listDeposits().then((d) => setTransferDeposits(d.data.data));
    // eslint-disable-next-line
  }, []);

  return (
    <Modal
      activator={activator}
      open={active}
      onClose={handleChange}
      title="Crear nuevo usuario"
      primaryAction={{
        content: 'Crear',
        onAction: handleSubmit,
        disabled: !pwconfirm,
      }}
    >
      <Modal.Section>
        <Form onSubmit={handleSubmit}>
          <FormLayout>
            <FormLayout.Group>
              <TextField
                label="Email"
                type="email"
                value={signUpForm.email}
                autoComplete="off"
                onChange={(e) =>
                  setSignUpForm({
                    ...signUpForm,
                    email: e,
                  })
                }
              />
              <TextField
                label="Contraseña"
                type="password"
                value={signUpForm.password}
                autoComplete="off"
                onChange={(e) =>
                  setSignUpForm({
                    ...signUpForm,
                    password: e,
                  })
                }
              />
              <TextField
                label="Confirmar contraseña"
                type="password"
                value={pwconfirmValue}
                autoComplete="off"
                onChange={(e) => {
                  setPwconfirmValue(e);
                  setPwconfirm(e !== '' && e === signUpForm.password);
                }}
                error={pwconfirmValue !== '' && !pwconfirm ? 'Las contraseñas no coinciden' : ''}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextField
                label="Nombre"
                type="name"
                value={signUpForm.name}
                autoComplete="  off"
                onChange={(e) => {
                  setSignUpForm({
                    ...signUpForm,
                    name: e,
                  });
                }}
              />
              <TextField
                label="Apellidos"
                type="text"
                value={signUpForm.surname}
                autoComplete="off"
                onChange={(e) => setSignUpForm({ ...signUpForm, surname: e })}
              />

              <TextField
                label="Teléfono"
                type="tel"
                value={signUpForm.phone}
                autoComplete="off"
                onChange={(e) => setSignUpForm({ ...signUpForm, phone: e })}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <Select
                label="Rol"
                options={roles.map((r) => ({ label: r.name, value: r.slug }))}
                onChange={(v) => setSignUpForm({ ...signUpForm, role: v })}
                value={signUpForm.role}
              />

              {signUpForm.role === 'promotor' && (
                <>
                  <div style={{ paddingTop: '8px' }}>
                    <Checkbox
                      label="Puede ver valores de ventas"
                      checked={signUpForm.canViewSells}
                      onChange={(e) => setSignUpForm({ ...signUpForm, canViewSells: e })}
                    />
                    <hr />
                  </div>
                  <div style={{ paddingTop: '8px' }}>
                    <Multiselector
                      title="Depósitos válidos para operar"
                      deposits={operationDeposits}
                      selectedOptions={signUpForm.operationDeposits?.map((d) => d.id)}
                      onChange={(selected) =>
                        setSignUpForm({ ...signUpForm, operationDeposits: selected.map((d) => ({ id: d })) })
                      }
                    />
                    <Multiselector
                      title="Depósitos válidos para recibir transferencias"
                      deposits={transferDeposits}
                      selectedOptions={signUpForm.transferDeposits?.map((d) => d.id)}
                      onChange={(selected) =>
                        setSignUpForm({ ...signUpForm, transferDeposits: selected.map((d) => ({ id: d })) })
                      }
                    />
                  </div>
                </>
              )}
            </FormLayout.Group>
          </FormLayout>
        </Form>
      </Modal.Section>
    </Modal>
  );
};
